import { render, staticRenderFns } from "./customerDelete.vue?vue&type=template&id=bd99b44c&"
import script from "./customerDelete.vue?vue&type=script&lang=js&"
export * from "./customerDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports